<template>
  <div class="lg:flex lg:justify-center lg:mt-10">
    <header class="font-open-sans p-5 lg:p-10 lg:rounded-lg bg-blue-900 border-b-8 border-orange-400">
      <h1 class="text-3xl md:text-6xl font-black text-white mt-1 md:mt-3">Generacija popunjene PDF ankete</h1>
      <h4 class="text-sm md:text-xl text-gray-100 mt-2 md:mt-4 max-w-6xl">Kako biste generisali popunjenu PDF anketu (za
        učenika koji se prethodno upisao u bazu putem stranice, a nije im se preuzeo PDF.),
        potrebno je da sa Firebase konzole pronađete traženog učenika. Nakon što ste kliknuli ime učenika (potrebno je
        da jedino podaci tog učenika budu vidljivi na prozoru. Ako nisu, niste ga dobro odabrali.) kliknite na tri tačke
        u gornjem desnom uglu prozorčića, a potom odaberite opciju "export JSON". Otvorite spašeni dokument u programu
        kao što je notepad. Kopirajte podatke i unesite ih u prostor ispod.</h4>
    </header>
  </div>
</template>

<style scoped>

</style>